import { useEffect, useRef, useState } from "react";
import { ICategoryDesc } from "../../types/customizer";
import { FaArrowRightLong } from "react-icons/fa6";
import Rating from "../Rating";

import clsx from "clsx";

import leftArrow from '../../../assets/images/left-chevrolet.svg';
// import rightArrow from '../../../assets/images/right-chevrolet.svg';
import If from "../If";
import { APP_STYLES, DEFAULT_STYLES, isEmpty } from "../../../utils/basic";
import { useRingCustomizerContext } from "../../context/RingCustomizerContext";
import CustomEditor from "../CustomEditor";
import { Link } from "react-router-dom";

interface IMaterialInfo extends ICategoryDesc {
	onBack?: () => void
}

const MaterialInfo = ({ name, short_desc, link, emblem_link, image_url, properties, video_url }: IMaterialInfo) => {
	const {subpath} = useRingCustomizerContext();

	const contentRef = useRef<HTMLDivElement>(null);
  const [imageHeight, setImageHeight] = useState<any>();

  useEffect(() => {
    if (contentRef.current) {
      setImageHeight(window.innerWidth >= 1024 ? contentRef.current.clientHeight : '400px');
    }
  }, [short_desc, name]); // Update height when content changes

	const styles = APP_STYLES[subpath] || DEFAULT_STYLES;
	return (
    <div className='tw-w-full tw-px-5 tw-text-blue-900 tw-flex tw-flex-wrap'>
      <div className='tw-w-full lg:tw-w-1/2 tw-flex tw-flex-col tw-gap-2' ref={contentRef}>
        <div className='tw-border tw-border-solid tw-border-[#D5D5D5] tw-rounded tw-p-4'>
          <div className="tw-text-xl tw-mb-2 primary-font-family">{name}</div>
          <CustomEditor source={short_desc} readOnly={true} />
          <If condition={styles.showLearnMore && emblem_link}>
            <a target="_blank" href={emblem_link} className='tw-text-sm tw-text-blue-900 tw-mt-4 tw-mb-1.5 tw-inline-block tw-border-b tw-border-solid tw-border-blue-900'>
              learn more
            </a>
          </If>
        </div>
        <If condition={!['revolution', 'stonebrook-jewelry', 'foundry'].includes(subpath)}>
          <div className='tw-border tw-border-solid tw-border-[#D5D5D5] tw-rounded tw-p-4'>
            <div className="tw-flex tw-flex-wrap tw-justify-between">
              {properties.map(prop => (<div className="tw-text-center tw-w-1/2 sm:tw-flex-1 tw-px-1.5 tw-flex tw-flex-col tw-items-center">
                <img src={prop.image_url} alt={prop.name} className="tw-h-7" />
                <div className="tw-text-base lg:tw-text-sm tw-text-blue-900">{prop.name}</div>
              </div>))}
            </div>
          </div>
        </If>
      </div>
      <div className='tw-w-full lg:tw-w-1/2 tw-pt-2 lg:tw-pt-0 lg:tw-pl-2'>
        <If condition={imageHeight && video_url}>
          <video style={{ height: imageHeight }}
            src={video_url}
            autoPlay={true}
            loop={true}
            muted={true}
            playsInline={true}
            className="tw-object-cover tw-w-full"
          />
        </If>
        <If condition={imageHeight && image_url && !video_url}>
          <img
            className='tw-rounded-md tw-w-full tw-object-cover'
            style={{ height: imageHeight }}
            src={image_url}
            alt="Mountain"
          />
        </If>
      </div>
    </div>
  )
  // return (
	// 	<div>
	// 		<If condition={!!props.onBack}>
	// 			<div className="tw-inline-flex tw-items-center tw-cursor-pointer" onClick={props.onBack}>
	// 				<img src={leftArrow} alt="left_arrow" className="tw-mr-1"/>
	// 				<button>Back</button>
	// 			</div>
	// 		</If>
	// 		<div className="tw-px-6 tw-pt-4 tw-font-bold tw-text-xl tw-mb-4 primary-font-family tw-text-primary-color">{props.name}</div>
	// 		<div className="tw-max-h-[550px] tw-overflow-auto secondary-font-family tw-text-secondary-color">
	// 			<div className="tw-px-6 tw-pb-4">
	// 				<p className="tw-text-gray-700 tw-text-sm tw-leading-6">
	// 					{props.short_desc}
	// 				</p>
	// 				<button className={clsx("tw-btn tw-font-bold tw-border-b tw-text-sm", {'tw-hidden': !styles.showLearnMore})} onClick={openLearnMore}>
	// 					Learn more &rarr;
	// 				</button>
	// 			</div>
	// 			<div className="tw-px-6 tw-pt-4 tw-pb-2">
	// 			<div className="tw-flex tw-items-center tw-justify-end">
	// 				<label className="tw-text-xs">Weight:</label>
	// 				{isEmpty(props.weight) ? <div className="tw-font-bold tw-text-sm tw-ml-1">N/A</div> : <Rating count={Number(props.weight)} />}
	// 			</div>
	// 			<div className="tw-flex tw-items-center tw-justify-end">
	// 				<label className="tw-text-xs">Scratch Resistance:</label>
	// 				{isEmpty(props.scratch_resistance) ? <div className="tw-font-bold tw-text-sm tw-ml-1">N/A</div> :
	// 					<Rating count={Number(props.scratch_resistance)} />}
	// 			</div>
	// 			</div>
	// 			<div className="tw-flex tw-justify-center tw-items-end tw-min-h-[150px] tw-max-h-[240px] tw-pr-3">
	// 				<img src={props.image_url ||'https://assets.staging.lashbrookdesigns.com/rings/profiles/D/widths/7/ring_materials/14KW/images/1?ring_finish=POLISH&finish_type=F&weight=P&size=10&feature_group=N&image_size=250'} alt="Mountain" />
	// 			</div>
	// 		</div>
	// 	</div>
  // );
};

export default MaterialInfo;
